module.exports = __webpack_public_path__ + "img/bh_17.f18f19a8.jpg";